import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { CircularProgress } from '@mui/material';

import { PublicSignerStateCard } from '@/pages/Public/ESignSigner/components/PublicSignerStateCard';

import { useCompletedDocumentDownload } from './useCompletedDocumentDownload';

export default function PublicCompletedDocumentDownloadPage() {
  const { '*': pathSuffix, token } = useParams<{
    '*': string | undefined;
    token?: string;
  }>();
  const downloadQuery = useCompletedDocumentDownload(token, pathSuffix);
  const startedDownloadUrlRef = useRef<string | null>(null);
  const [startedDownloadUrl, setStartedDownloadUrl] = useState<string | null>(
    null
  );

  useEffect(() => {
    const downloadUrl = downloadQuery.data?.downloadUrl;
    if (!downloadUrl || startedDownloadUrlRef.current === downloadUrl) {
      return;
    }

    startedDownloadUrlRef.current = downloadUrl;
    window.location.replace(downloadUrl);
    setStartedDownloadUrl(downloadUrl);
  }, [downloadQuery.data?.downloadUrl]);

  if (!token || downloadQuery.isError) {
    return (
      <PublicSignerStateCard
        description="Please contact the sender for a new link."
        severity="error"
        title="This document link is unavailable"
      />
    );
  }

  if (
    downloadQuery.isLoading ||
    !downloadQuery.data ||
    startedDownloadUrl !== downloadQuery.data.downloadUrl
  ) {
    return (
      <PublicSignerStateCard
        description="Verifying your link and preparing the file."
        icon={<CircularProgress aria-label="Preparing download" size={32} />}
        severity="info"
        title="Preparing your download"
      />
    );
  }

  return (
    <PublicSignerStateCard
      description="When it finishes, you will find the file in your Downloads folder."
      icon={<CheckCircleIcon fontSize="large" />}
      severity="success"
      title="Your download has started."
    />
  );
}
